import { render, staticRenderFns } from "./EbiList.vue?vue&type=template&id=4b789252&"
import script from "./EbiList.vue?vue&type=script&lang=js&"
export * from "./EbiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports